// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Ik2r3","error":"Button_error__StVEv","success":"Button_success__NIASW","primary":"Button_primary__Gs9eZ"};